import { Container } from "src/components/container"
import { FAQCollapse } from "./Collapse"
import { FAQ_LIST } from "./list"
import "./style.scss"

export const IBANFaq = () => {
  return (
    <div className="iban-faq-wrapper">
      <Container className="iban-faq">
        <h1>Frequently Asked Questions</h1>
        {FAQ_LIST.map(({ content, title }) => (
          <FAQCollapse title={title}>{content}</FAQCollapse>
        ))}
      </Container>
    </div>
  )
}
